import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import "./i18n/i18n";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import store from "./store";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { BookingParamProvider } from "./components/BookingParamContext";

ReactDOM.render(
  <BookingParamProvider>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </BookingParamProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
